import React, { useState, useEffect } from "react";
import "./Section4.css";

const galleryImages = [
  {
    src: "/section4_Lathroon.png",
    place: "Lathroun Resort",
    description: "Set in the picturesque coastal town of Lathroun, Libya, the Lathroun Resort is a sanctuary of tranquility and luxury, the resort is designed with a focus on seclusion and scenic beauty.",
  },
  {
    src: "/alahly_mobile_section4.png",
    place: "Al Ahly Mall",
    description: "Nestled in the vibrant city of Benghazi, the Al Ahly Mall and Hotel project stands as a beacon of Modern tranquility. Covering an expansive area of 40,000 sqm.",
  },
  {
    src: "/section4_Endair.png",
    place: "Endair Towers",
    description: "Overlooking the Mediterranean Sea this trio of towers comprises a luxurious hotel, a bustling mall and a state-of-the-art office building. The integration of these three distinct functions within a single complex.",
  },
  {
    src: "/section4_Ozou.png",
    place: "Ouzo Hotel ",
    description: "The Ouzo Hotel, situated in the picturesque location of Benghazi, Libya, overlooking the 23rd of July Lake.",
  },
];

export default function Section4() {
  const [currentIndex, setCurrentIndex] = useState(0);

  // auto slider (no arrow needed)
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % galleryImages.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const current = galleryImages[currentIndex];

  return (
    <div className="section4">
      
      <div className="section4-inner">

        {/* LEFT (UNCHANGED CONTENT) */}
        <div className="section4-left-content">
          <h2 className="section4-section-title">Projects </h2>
          <div className="section4-place-name">{current.place}</div>
          <p className="section4-description">{current.description}</p>

          <button className="section4-learn-more-button">
            Learn More
          </button>
        </div>

        {/* RIGHT */}
        <div className="section4-right-content">
          <img
            src={current.src}
            alt={current.place}
            className="section4-gallery-image"
          />
        </div>

      </div>

    </div>
  );
}